import { EventBadgesProps } from './EventBadgesProps';
import { useEventBadges } from './useEventBadges';

const numBadgesWithoutStacking = 2;

export function EventBadges({ trip, type }: EventBadgesProps) {
  const badges = useEventBadges({ trip, type });

  return (
    <div
      className="group absolute -right-0.5 -top-1 flex gap-0.5"
      data-testid={`event-badges-${trip.id}`}
    >
      {badges.map((badge, idx) => (
        <div
          key={idx}
          className={`${
            // TODO: Could make this more complicated by checking width of container and only stacking if there's not enough space
            badges.length > numBadgesWithoutStacking && idx > 0
              ? '-ml-[.65rem] group-hover:ml-1'
              : ''
          } transition-all duration-200`}
        >
          {badge}
        </div>
      ))}
    </div>
  );
}
